
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, OffcanvasBody, OffcanvasHeader, Table } from "reactstrap";
import { errorHandler, toLocaleTime } from "utils/Api";
import DefaultOffCanvas from "../DefaultOffCanvas";
import { Box } from 'react-bootstrap-icons';
import styles from "./style.module.scss"
import cx from "classnames";
import { getPackages } from "api/PackagesApi";

const SearchPackagesOffCanvas = props => {
    const { btnColor = "primary", className, onSelect, currentSelection = {}, searchFilter = {} } = props;
    const [isOpen, setOpen] = useState(false);
    const [boxesList, setBoxesList] = useState([]);
    const [selectedBoxesList, setSelectedBoxesList] = useState({});

    useEffect(() => {
        fetchPackages();
    }, [boxesList.length]);

    useLayoutEffect(() => {
        setSelectedBoxesList(currentSelection);
    }, [currentSelection.length, currentSelection]);

    const fetchPackages = () => {
        getPackages({
            filter: searchFilter
        }).then((response) => {
            const { items: boxes } = response
            setBoxesList(boxes);
        }).catch((e) => errorHandler(e, "Fetch Boxes list error"));
    }

    const toogleSelectedBox = (box) => {
        let newSelectedBoxes = { ...selectedBoxesList };

        if (selectedBoxesList[box.id]) {
            delete newSelectedBoxes[box.id];
        } else {
            newSelectedBoxes[box.id] = box;
        }
        setSelectedBoxesList(newSelectedBoxes)
    }

    const renderList = () => {
        return boxesList.map((box) => {
            let created = toLocaleTime(box.createdAt);
            return (
                <tr key={box.id} className={cx({
                    [styles.rowSelected]: selectedBoxesList[box.id],
                })}>
                    <td>
                        {box.secuencia}
                    </td>
                    <td>
                        {box.warehouseNumber}
                    </td>
                    <td>
                        {box.client}
                    </td>
                    <td>
                        {box.tracking_num}
                    </td>
                    <td>
                        {created}
                    </td>
                    <td>
                        <Box className={cx({
                            [styles.box_btn]: true,
                            [styles.selected]: selectedBoxesList[box.id],
                        })} onClick={(e) => { toogleSelectedBox(box); }} size="1.5rem" />
                    </td>
                </tr>
            );
        });
    }

    const addSelected = (e) => {
        if (onSelect) {
            onSelect(selectedBoxesList);
        }
        setOpen(false);
    }

    const toogleOffCanvas = (newState) => {
        if (newState) {
            setSelectedBoxesList(currentSelection || {});
        }
        setOpen(newState);
    }

    return (
        <>
            <Button
                color={btnColor}
                className={className}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader toggle={() => toogleOffCanvas(!isOpen)}>
                    Buscar Paquetes
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Button className="float-end" type="button" onClick={(e) => addSelected(e)} color="success"> Agregar</Button>
                    <Table hover>
                        <thead>
                            <tr>
                                <th>
                                    #
                                </th>
                                <th>
                                    Warehouse
                                </th>
                                <th>
                                    Cliente
                                </th>
                                <th>
                                    Tracking
                                </th>
                                <th>
                                    Fecha Ingreso
                                </th>
                                <th width="2%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderList()}
                        </tbody>
                    </Table>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default SearchPackagesOffCanvas;
